import axios from 'axios';
import { attachDataExtractInterceptor } from './interceptors/dataExtractInterceptor';

export const goalOfMonthClient = axios.create({ withCredentials: false });
attachDataExtractInterceptor(goalOfMonthClient);
